import React, { useEffect, useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import { FormikProvider, useFormik } from "formik"
import * as yup from "yup"
import { PopupQuestion } from "../../../../component/atoms/Popup/index.jsx"
import { UploadComponent } from "../../../../component/index.jsx"
import { UploadIcon } from "../../../../component/atoms/Icons/SVG/upload.jsx"
import { VARIABLE_CONSTANT } from "../../../../constants/VariableConstant.js"
import { UPLOAD } from "../../../../constants/InitTypeConstants.js"
import { resetUrlResponse, uploadAction } from "../../../../redux/actions/MasterDataAction.jsx"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

export const ModalFreezeArea = ({
  show = false,
  onClose = () => {},
  onSubmit = () => {},
}) => {
  const dispatch = useDispatch()
  const { General, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()

  const [fileAttachments, setFileAttachments] = useState([])

  const validationSchema = yup.object({
    reason: yup.string().required(t("label_error_required", { label: t("label_reason") })),
    file_contract_url: yup.string().required(t("label_error_required", { label: t("label_document") }))
  })

  const formik = useFormik({
    initialValues: {
      reason: "",
      file_contract_url: "",
      file_name: "",
      file_size: ""
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values)
      handleClose()
    }
  })

  useEffect(() => {
    if (!show) {
      formik.resetForm()
      setFileAttachments([])
    }
  }, [show])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (!General.loading) {
        if (MasterData.uploadType === UPLOAD.BUSINESS_DOCUMENT) {
          formik.setFieldValue("file_contract_url", MasterData.urlResponseUpload)
        }
      }
      setTimeout(() => {
        dispatch(resetUrlResponse())
      }, 200)
    }
  }, [MasterData.urlResponseUpload, General.loading, MasterData.uploadType])

  const handleClose = () => {
    formik.resetForm()
    setFileAttachments([])
    onClose()
  }

  const handleFileUpload = (file) => {
    setFileAttachments([file])
    formik.setFieldValue("file_name", file.name)
    formik.setFieldValue("file_size", file.size)
    dispatch(uploadAction({ data: file, type: UPLOAD.BUSINESS_DOCUMENT }))
  }

  const handleDeleteFile = () => {
    setFileAttachments([])
    formik.setFieldValue("file_contract_url", "")
    formik.setFieldValue("file_name", "")
    formik.setFieldValue("file_size", "")
  }

  const renderBody = () => (
    <div>
      <div className="mb-3">
        <label>
          {t("input_change_area_status_reason")}
          <span className="text-danger ml-1" aria-hidden="true">*</span>
        </label>
        <textarea
          required={true}
          rows={4}
          className={`form-control ${
            formik.touched.reason && formik.errors.reason ? "is-invalid" : ""
          }`}
          name="reason"
          value={formik.values.reason}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder={t("placeholder_input_reason")}
        />
        {formik.touched.reason && formik.errors.reason && (
          <div className="invalid-feedback d-block">{formik.errors.reason}</div>
        )}
      </div>

      <div className="mb-3 position-relative">
        <UploadComponent
          label={t("contract_document")}
          required={true}
          name="document_freeze_area"
          onDeleteFileList={handleDeleteFile}
          fileList={fileAttachments}
          typeUpload={"pdf"}
          editable={true}
          onChange={handleFileUpload}
          placeholder={<UploadIcon />}
          maxSize={VARIABLE_CONSTANT.MAX_SIZE_25_MB}
          maxSizeText={VARIABLE_CONSTANT.MAX_SIZE_25_MB_TEXT}
          isLoading={General.loading}
          // customFilePreview={{ top: "calc(65% + 20px - 1.25rem)" }}
        />
        {formik.touched.file_contract_url && formik.errors.file_contract_url && (
          <div className="invalid-feedback d-block">{formik.errors.file_contract_url}</div>
        )}
      </div>

      <Row className="justify-content-center mt-4">
        <Col>
          <Button
            className="font-weight-bold w-100"
            variant="outline-primary"
            block={true}
            onClick={handleClose}>
            {t("button_batal")}
          </Button>
        </Col>
        <Col>
          <Button
            className="font-weight-bold w-100"
            variant={
              "primary"
            }
            disabled={!formik.values.reason || !formik.values.file_contract_url}
            block={true}
            onClick={() => formik.handleSubmit()}>
            {t("button_next")}
          </Button>
        </Col>
      </Row>
    </div>
  )

  return (
    <FormikProvider value={formik}>
      <PopupQuestion
        show={show}
        title={t("label_freeze").toUpperCase()}
        bodyCustom={renderBody()}
        isUseFooter={false}
        onCancel={handleClose}
        closeButton={false}
        centered={true}
      />
    </FormikProvider>
  )
}
